export default {
  namespaced: true,
  state: {
    center: undefined,
    bounds: {},
    filter: {
      open: true,
      delivery: false,
      pickup: false,
    },
    isAddModeEnable: false,
  },
  actions: {
    setCenter({ commit }, center) {
      commit('setCenter', center);
    },
    setBounds({ commit }, bounds) {
      commit('setBounds', bounds);
    },
    setOpen({ commit }, status) {
      commit('setOpen', status);
    },
    setDelivery({ commit }, status) {
      commit('setDelivery', status);
    },
    setPickup({ commit }, status) {
      commit('setPickup', status);
    },
    enableAddMode({ commit }) {
      commit('setAddMode', true);
    },
    disableAddMode({ commit }) {
      commit('setAddMode', false);
    },
  },
  mutations: {
    setCenter(state, center) {
      state.center = center;
    },
    setBounds(state, bounds) {
      state.bounds = bounds;
    },
    setOpen(state, status) {
      state.filter.open = status;
    },
    setDelivery(state, status) {
      state.filter.delivery = status;
    },
    setPickup(state, status) {
      state.filter.pickup = status;
    },
    setAddMode(state, status) {
      state.isAddModeEnable = status;
    },
  },
};
